export default __webpack_public_path__ + "static/media/low-risk.40f1e46e.webp";